import "./Courses.module.css";
import Header from "@/reusable_sections/Header";
import LinkedinLearningCourses from "./sections/LinkedinLearningCourses";
import CourseListing from "./sections/CourseListing";
import Footer from "@/reusable_sections/Footer";
export default function CoursesPage() {
  return <div>
      <Header />
      <LinkedinLearningCourses />
      <CourseListing />
      <Footer />
    </div>;
}